import React from 'react'
import './styles.css'

const TextInput = ({
  label,
  placeholder,
  value,
  onChange,
  name,
  error,
  ...props
}) => {
  return (
    <div className="text-input-container">
      {label && <label className="text-input-label">{label}</label>}
      <input
        type="text"
        className={`text-input-field ${error ? 'error' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        {...props}
      />
      {error && <div className="text-input-error">{error}</div>}
    </div>
  )
}

export default TextInput
